export default "__VITE_ASSET__6cdeca5d__"